// 初始化数据
const modals = {
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  searchResult: [], //查询结果数据
  searchParams: {
    // 'supplierCode': {value: '39999413', children: 'sss'},
    // 'companyCode': {value: '2111', children: '啦啦啦'},
  }, // 搜索传值
  tableLoading: false, // 列表loading
  superClass: 0, //tool工具栏按钮状态
  selectedRowKeys: [], //table选中的数据
  selectedRowItems: [],
  tabList: [
    { name: '供应商未确认', num: '' },
    { name: '供应商已确认财务未确认', num: '' },
    { name: '财务已确认待开票', num: '' },
    { name: '供应商已开票', num: '' },
    { name: '已票核待生成付款单', num: '' },
    { name: '已生成付款单待付款', num: '' },
    { name: '已付款确认', num: '' },
  ],
  statisticalData: null, //工具栏的所有金额合计
  isShowSign: true, //是否显示签章按钮
  ReconciliationConfirmation: false,
  CheckCheck: false, // 是否拥有勾票确认权限
  TicketCancellation: false, // 是否拥有勾票取消权限
  InvoiceEntry: false, // 是否拥有发票录入权限
};
export default modals;
